import React, { useEffect } from 'react';
import { useDismissableNotification } from '../Notifications/Notification/useDismissableNotification';
import LiveNotificationCard from './_partials/LiveNotificationCard';
import { useBiLogger } from '../biLogger/hooks/useBiLogger';
import BiLink from '../biLogger/Components/BiLink';
import BiSpan from '../biLogger/Components/BiSpan';
import { useFlag } from '../redux/flags/hooks';
import { BiEventType } from '../biLogger';
var LiveNotification = function (_a) {
    var id = _a.id, queueName = _a.queueName, notificationHtml = _a.notificationHtml, linkTo = _a.linkTo;
    var logBiEvent = useBiLogger();
    var testBiLogging = useFlag('yumeruby');
    var _b = useDismissableNotification({
        id: id,
        queueName: queueName,
        duration: 10000,
    }), onClose = _b.onClose, onPause = _b.onPause, onUnpause = _b.onUnpause;
    useEffect(function () {
        if (!testBiLogging) {
            return;
        }
        logBiEvent({
            evid: BiEventType.TEST,
            itemid: id,
        });
    }, [logBiEvent, id, testBiLogging]);
    return (React.createElement(LiveNotificationCard, { onClose: onClose, onMouseEnter: onPause, onMouseLeave: onUnpause }, linkTo ? (React.createElement(BiLink, { href: linkTo, dangerouslySetInnerHTML: { __html: notificationHtml }, biData: {
            evid: BiEventType.DEFAULT,
            click_info: 'liveNotification.click',
        } })) : (React.createElement(BiSpan, { dangerouslySetInnerHTML: { __html: notificationHtml }, biData: {
            evid: BiEventType.DEFAULT,
            click_info: 'liveNotification.click',
        } }))));
};
LiveNotification.displayName = 'LiveNotification';
export default LiveNotification;
//# sourceMappingURL=LiveNotification.js.map